import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class AdminWarehouseApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.MANAGEMENT_WAREHOUSE);
  }

  getById(id) {
    return this.httpClient.get(`${this.getResourceUrl()}detail/${id}/`);
  }

  updatePurchaseOrderAddress(warehouseId, data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${warehouseId}/purchase-order-address/`,
      data,
    );
  }

  // --- Gate pass document addresses (billing/shipping) ---
  _getWarehouseDomainStrict(targetWarehouseId) {
    try {
      const candidates = ['authInfo', 'warehouse'];
      for (const key of candidates) {
        const raw = localStorage.getItem(key);
        if (!raw) continue;

        const obj = JSON.parse(raw);
        const permissions = obj?.warehouse_permissions;

        if (Array.isArray(permissions)) {
          const match = permissions.find(
            p => p?.warehouse?.id === targetWarehouseId,
          );
          if (match?.warehouse?.domain) {
            const domain = match.warehouse.domain.trim();
            if (domain && !/^\d+$/.test(domain)) return domain;
          }
        }
      }
    } catch (e) {
      const err = new Error('WAREHOUSE_DOMAIN_NOT_AVAILABLE');
      err.code = 'WAREHOUSE_DOMAIN_NOT_AVAILABLE';
      err.details = e?.message;
      throw err;
    }
  }

  _buildGatePassAddressEndpoint(
    warehouseId,
    type,
    method /* 'POST' | 'PATCH' */,
  ) {
    const baseUrl = this.getResourceUrl();
    const domain = this._getWarehouseDomainStrict(warehouseId); // 인자 전달

    const replacedBase = baseUrl.replace(
      /^(\/c\/[^/]+\/)[^/]+\//,
      `$1${encodeURIComponent(domain)}/`,
    );

    const pathPart =
      type === 'billing'
        ? 'gate-pass-billing-address/'
        : 'gate-pass-shipping-address/';

    const suffix = method === 'PATCH' ? 'update/' : '';

    return `${replacedBase}${pathPart}${suffix}`;
  }

  updateGatePassAddress(warehouseId, type, data) {
    const endpoint = this._buildGatePassAddressEndpoint(
      warehouseId,
      type,
      'PATCH',
    );
    return this.httpClient.patch(endpoint, data);
  }

  createGatePassAddress(warehouseId, type, data) {
    const endpoint = this._buildGatePassAddressEndpoint(
      warehouseId,
      type,
      'POST',
    );
    return this.httpClient.post(endpoint, data);
  }

  updateChannelSetting(warehouseDomain, channelId, data) {
    const baseUrl = this.getResourceUrl();
    const replacedBase = baseUrl.replace(
      /^(\/c\/[^/]+\/)[^/]+\//,
      `$1${encodeURIComponent(warehouseDomain)}/`,
    );
    return this.httpClient.patch(
      `${replacedBase}channel-setting/${channelId}/update/`,
      data,
    );
  }
}

export default new AdminWarehouseApi();
